export default __webpack_public_path__ + "static/media/fiberhome.50922fcc.jpg";